<template>
  <div class="my-12">
    <carousel
    ref="carousel"
    :perPage="1"
    :paginationEnabled="false"
    :navigateTo="navigateTo"
    class="w-full mx-auto"
    @pageChange="handlePageChange"
  >
    <slide
      v-for="(image, imageIndex) in images"
      :key="'image-' + imageIndex"
      class="w-full"
    >
      <div
        class="relative w-full"
        :style="aspectRatioPaddingStyle"
      >
        <img
          class="absolute top-0 left-0 w-full h-full object-contain"
          v-lazy="image.src"
          :data-srcset="image.srcset"
        />
      </div>
    </slide>
    </carousel>

    <div
      v-if="currentCaption"
      class="text-sm text-center mt-2"
      v-html="currentCaption"
    ></div>

    <div class="flex items-center justify-center mt-4">
      <button
        v-for="(image, imageIndex) in images"
        :key="'dot-' + imageIndex"
        type="button"
        class="rounded-full focus:outline-none mx-1 transition-colors duration-200"
        style="width: 6px; height: 6px;"
        :class="imageIndex === currentSlide ? 'bg-black' : 'bg-gray-500'"
        :aria-label="'Go to slide ' + (imageIndex + 1)"
        :aria-current="imageIndex === currentSlide ? 'true' : 'false'"
        @click="goToSlide(imageIndex)"
      ></button>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'ImageCarousel',

  props: ['images'],

  data () {
    return {
      currentSlide: 0,
      navigateTo: 0
    }
  },

  components: {
    Carousel,
    Slide
  },

  computed: {
    aspectRatioPaddingStyle () {
      let widestAspectRatio = 1
      let w = 1
      let h = 1
      this.images.forEach(i => {
        if (!i.dimensions || !i.dimensions.width || !i.dimensions.height) {
          return
        }

        const ratio = i.dimensions.width / i.dimensions.height
        if (ratio > widestAspectRatio) {
          widestAspectRatio = ratio
          w = i.dimensions.width
          h = i.dimensions.height
        }
      })

      return `padding-top:calc(100%/(${w}/${h}));`
    },

    currentCaption () {
      const image = this.images[this.currentSlide]
      if (!image || !image.content || !image.content.caption) {
        return ''
      }

      return image.content.caption
    }
  },

  watch: {
    images: {
      immediate: true,
      handler (nextImages) {
        const hasImages = Array.isArray(nextImages) && nextImages.length > 0
        if (!hasImages) {
          this.currentSlide = 0
          this.navigateTo = 0
          return
        }

        if (this.currentSlide >= nextImages.length) {
          this.currentSlide = 0
          this.navigateTo = 0
        }
      }
    }
  },

  methods: {
    handlePageChange (page) {
      this.currentSlide = page
    },

    goToSlide (index) {
      this.currentSlide = index
      this.navigateTo = index
    }
  }
}
</script>